jQuery(document).ready(function(){
  jQuery('.popup-youtube').click(function(e){
    e.preventDefault();
    console.log('test');
  	var url = jQuery(this).attr('href');
    if(url.indexOf("spinzam") > -1){
      jQuery('.mfp-iframe').attr('scrolling','no');
      jQuery('.mfp-content').addClass('spinzamDiv');
      jQuery('.mfp-container').addClass('spinzamFixed');
    }
  });
})

